import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
var HttpClient = /** @class */ (function () {
    function HttpClient(http, authService, router) {
        this.http = http;
        this.authService = authService;
        this.router = router;
    }
    HttpClient.prototype.createAuthorizationHeader = function () {
        var headers = new Headers({ 'Authorization': 'Bearer ' + this.authService.token });
        var options = new RequestOptions({ headers: headers });
        return options;
    };
    HttpClient.prototype.get = function (url, isFile) {
        var options = this.createAuthorizationHeader();
        if (isFile) {
            options.headers.append('Content-Type', 'application/json');
            options.headers.append('Accept', 'application/json');
            options.responseType = ResponseContentType.Blob;
        }
        return this.intercept(this.http.get(environment.API_ENDPOINT + url, options));
    };
    HttpClient.prototype.post = function (url, data) {
        var options = this.createAuthorizationHeader();
        return this.intercept(this.http.post(environment.API_ENDPOINT + url, data, options));
    };
    HttpClient.prototype.postWithFile = function (url, postData, fileData) {
        var formData = new FormData();
        if (postData !== "" && postData !== undefined && postData !== null) {
            for (var property in postData) {
                if (postData.hasOwnProperty(property)) {
                    formData.append(property, postData[property]);
                }
            }
        }
        formData.append(fileData.name, fileData.file, fileData.file.name);
        var options = this.createAuthorizationHeader();
        //options.headers.append('Content-Type', 'multipart/form-data');
        //options.headers.append('Accept', 'application/json');
        return this.intercept(this.http.post(environment.API_ENDPOINT + url, formData, options));
    };
    HttpClient.prototype.postWithFiles = function (url, postData, fileData) {
        var formData = new FormData();
        if (postData !== "" && postData !== undefined && postData !== null) {
            for (var property in postData) {
                if (postData.hasOwnProperty(property)) {
                    formData.append(property, postData[property]);
                }
            }
        }
        debugger;
        fileData.forEach(function (element) {
            formData.append(element.name, element.file, element.file.name);
        });
        var options = this.createAuthorizationHeader();
        //options.headers.append('Content-Type', 'multipart/form-data');
        //options.headers.append('Accept', 'application/json');
        return this.intercept(this.http.post(environment.API_ENDPOINT + url, formData, options));
    };
    HttpClient.prototype.put = function (url, data) {
        var options = this.createAuthorizationHeader();
        return this.intercept(this.http.put(environment.API_ENDPOINT + url, data, options));
    };
    HttpClient.prototype.delete = function (url) {
        var options = this.createAuthorizationHeader();
        return this.intercept(this.http.delete(environment.API_ENDPOINT + url, options));
    };
    HttpClient.prototype.intercept = function (observable) {
        var _this = this;
        return observable.catch(function (err, source) {
            if (err.status == 401) {
                _this.authService.logout();
                _this.router.navigate(['/login']);
                return Observable.empty();
            }
            else {
                return Observable.throw(err);
            }
        });
    };
    HttpClient.ctorParameters = function () { return [{ type: Http }, { type: AuthService }, { type: Router }]; };
    return HttpClient;
}());
export { HttpClient };
//# sourceMappingURL=http-client.js.map


// WEBPACK FOOTER //
// http-client.js